import { CatHeading } from '@blocks-react/components/Heading';
import { useBreakpoint } from '../../../../hooks';
import { PAGE_BREAKPOINTS } from '../../../../constants/commonConstants';
import { ServiceInsightImpactTitleProps } from '../../types';
import styles from '../../customer-account.module.scss';

export const ServiceInsightImpactTitle = ({
  title,
  impact
}: ServiceInsightImpactTitleProps) => {
  const isTablet = useBreakpoint(PAGE_BREAKPOINTS.MD);
  return (
    <>
      <CatHeading variant="label" className={styles['title']}>
        {title}
      </CatHeading>
      {isTablet && (
        <CatHeading className={styles['description']} variant="footnote">
          {impact}
        </CatHeading>
      )}
    </>
  );
};
